export class GeneralErrorService {
  private static instance: GeneralErrorService

  private isVisible: boolean

  private constructor() {
    this.isVisible = false
  }

  setIsVisible(isVisible: boolean) {
    this.isVisible = isVisible
  }

  getIsVisible(): boolean {
    return this.isVisible
  }

  static getInstance(): GeneralErrorService {
    if (!GeneralErrorService.instance) {
      GeneralErrorService.instance = new GeneralErrorService()
    }

    return GeneralErrorService.instance
  }
}
